import * as React from 'react'
import { Checkbox } from 'src/share/components/Checkbox/Checkbox'
import { capitalize } from 'src/share/utils/utils';

enum statusFilterTypes {
  ACTIVE = 'ACTIVE',
  SENT = 'SENT',
  STOPPED = 'STOPPED',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
}


const initialStatusFilters = { 
  [statusFilterTypes.ACTIVE]: false,
  [statusFilterTypes.SENT]: false, 
  [statusFilterTypes.STOPPED]: false, 
  [statusFilterTypes.WARNING]: false,
  [statusFilterTypes.ERROR]: false,
  [statusFilterTypes.EXPIRED]: false 
}

const AlertStatusModal = ({ isActive, onToggle, onApply }): React.ReactElement => {
  const [statusFilters, setStatusFilters] = React.useState(initialStatusFilters);
  const handleClearFilters = (): void => setStatusFilters(initialStatusFilters);
  const handleChange = (key) => (bool): void => setStatusFilters({ ...statusFilters, [key]: bool });
  const handleApply = (): void => onApply(Object.keys(statusFilters).filter(key => statusFilters[key]));
  return (
    <div className={`modal-container ${isActive ? "active" : ""}`}>
      <div className="backdrop" onClick={onToggle} />
      <div className="modal-card alert-status-modal">
        <h5>Filter the results by status</h5>
        <div className="alert-status-selector">
          <button className="btn-outline filters-reset" onClick={handleClearFilters}>Clear All <span className="fa fa-reset" /></button>
          {Object.keys(statusFilters).map(key => (
            <Checkbox disabled={false} label={capitalize(key)} checked={statusFilters[key]} onChange={handleChange(key)} />
          ))}
        </div>
        <div className="actions-group">
          <button className="bg-blue" onClick={handleApply}>Apply</button>
          <button onClick={onToggle}>Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default AlertStatusModal



// WEBPACK FOOTER //
// ./src/modules/Alert/ControlCenter/components/AlertStatusModal.tsx